import moment from "moment-timezone";

export function timezonesForCountry(countryCode) {
  return countryCode ? moment.tz.zonesForCountry(countryCode, true) : [];
}

export function countryOptions(language) {
  const names = new Intl.DisplayNames([language], { type: "region" });
  return moment.tz.countries()
    .map((code) => ({ value: code, label: names.of(code) || code }))
    .sort((left, right) => left.label.localeCompare(right.label, language));
}

export function timezoneOptions(countryCode) {
  return timezonesForCountry(countryCode).map(({ name, offset }) => ({
    value: name,
    label: `${name} (UTC${offset <= 0 ? "+" : "-"}${String(Math.floor(Math.abs(offset) / 60)).padStart(2, "0")}:${String(Math.abs(offset) % 60).padStart(2, "0")})`,
  }));
}
